import React from 'react'
import { useIntl } from 'react-intl'
import search from '../../../assets/imgs/buttons/search.svg'
import InputTextComp from '../form-components/inputs/InputTextComp'
import './search.scss'

const Search = ({ placeholder, filter, updateFilter }) => {
  const { formatMessage: msg } = useIntl()

  return (
    <div className="search">
      <img className="imgSearch" src={search} alt="search" />
      <InputTextComp
        className="search-input"
        value={filter}
        onChange={updateFilter}
        placeholder={
          (placeholder && msg({ id: `${placeholder}` })) ||
          msg({ id: 'search' })
        }
      />
    </div>
  )
}

export default Search
